require('./$.species')(Array);


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/es6.array.species.js
 ** module id = 672
 ** module chunks = 0
 **/